/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-19 14:44:15
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:55:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/index.tsx
 */
import React from 'react';
//import css from './css.module.less';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import { dispatch } from 'src/store';

import { PreviewStyleSwitch } from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import {
  ChannelType,
  EPreviewSize,
  WebSiteSubType,
} from 'src/types/common/SalesChannel';
import CloneBtn from './CloneButton';
import FlashSaleBarStyle from './FlashSaleBarStyle';
import FloatingActionsBar from './FloatingActionButtonStyle';
import Font from './Font';
import MiniProgramNavigationBar from './MiniProgramNavigationBar';
import Primary from './PrimaryActionButtonStyle';
import RemainingStockTextStyle from './RemainingStockTextStyle';
import Secondary from './SecondaryActionButtonStyle';
import TabBarStyle from './TabBarStyle';

import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';

import {
  fetchContentAppearance,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getShowRemainingStock,
  getState,
  resetData,
  submitContentAppearance,
  validation,
} from './slice';

//import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useParams } from 'react-router-dom';
import LoadingAnimation from './LoadingAnimation';
import Preview from './Preview';
import TopLeaderBoardBanner from './TopLeaderBoardBanner';
import { convertDataFromReduxToServer } from './tools';

const SalesChannelAppearanceEditorPage = (props) => {
  const {
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded,
    onDiscard,
    currentStyle,
    currentSize,
    isOnPrimaryLanguage,
    isMini,
  } = props;
  const _d = useDispatch();
  const showRemainingStock = getShowRemainingStock();
  const channelType = useSalesChannelType();
  const isResponsive = currentStyle === WebSiteSubType.ResponsivePage;
  const _params: {
    saleChannelUuid: string;
    contentUuid: string;
  } = useParams();
  const { contentUuid } = _params;

  React.useEffect(() => {
    // _d(
    //   fetchContentAppearance({
    //     uuid: contentUuid,
    //   }),
    // );
    return () => {
      _d(resetData());
    };
  }, []);

  const ele = React.useMemo(() => {
    switch (currentStyle) {
      case WebSiteSubType.NativeMobile: {
        if (isOnPrimaryLanguage) {
          return [
            {
              body: (
                <React.Fragment>
                  <LoadingAnimation isPrimary={isOnPrimaryLanguage} />
                  <TabBarStyle isPrimary={isOnPrimaryLanguage} />
                  <FlashSaleBarStyle isPrimary={isOnPrimaryLanguage} />
                  <Primary isPrimary={isOnPrimaryLanguage} />
                  <Secondary isPrimary={isOnPrimaryLanguage} />
                  {showRemainingStock && (
                    <RemainingStockTextStyle isPrimary={isOnPrimaryLanguage} />
                  )}
                  {channelType === ChannelType.MiniProgram && (
                    <MiniProgramNavigationBar />
                  )}
                </React.Fragment>
              ),
              key: 'topConfig',
            },
            {
              body: (
                <React.Fragment>
                  <Font isPrimary={isOnPrimaryLanguage} />
                </React.Fragment>
              ),
              key: 'Font',
            },
          ];
        } else {
          return [
            {
              body: (
                <React.Fragment>
                  <CloneBtn />
                  <Font isPrimary={isOnPrimaryLanguage} />
                </React.Fragment>
              ),
              key: 'Font',
            },
          ];
        }
      }
      case WebSiteSubType.ResponsivePage: {
        switch (currentSize) {
          case EPreviewSize.WIDE: {
            if (isOnPrimaryLanguage) {
              return [
                {
                  body: (
                    <React.Fragment>
                      <LoadingAnimation isPrimary={isOnPrimaryLanguage} />
                      <TopLeaderBoardBanner
                        currentSize={currentSize}
                        currentStyle={currentStyle}
                        salesChannelContentUuid={contentUuid}
                        isPrimary={isOnPrimaryLanguage}
                      />
                      <TabBarStyle
                        isPrimary={isOnPrimaryLanguage}
                        isResponsive={isResponsive}
                      />
                      <FlashSaleBarStyle isPrimary={isOnPrimaryLanguage} />
                      <Primary isPrimary={isOnPrimaryLanguage} />
                      <Secondary isPrimary={isOnPrimaryLanguage} />
                      <FloatingActionsBar />
                      {showRemainingStock && (
                        <RemainingStockTextStyle
                          isPrimary={isOnPrimaryLanguage}
                        />
                      )}
                      {channelType === ChannelType.MiniProgram && (
                        <MiniProgramNavigationBar />
                      )}
                    </React.Fragment>
                  ),
                  key: 'topConfig',
                },
              ];
            } else {
              return [
                {
                  body: (
                    <React.Fragment>
                      <TopLeaderBoardBanner
                        currentSize={currentSize}
                        currentStyle={currentStyle}
                        salesChannelContentUuid={contentUuid}
                        isPrimary={isOnPrimaryLanguage}
                      />
                    </React.Fragment>
                  ),
                  key: 'Font',
                },
              ];
            }
          }
          case EPreviewSize.TABLET: {
            if (isOnPrimaryLanguage) {
              return [
                {
                  body: (
                    <React.Fragment>
                      <TopLeaderBoardBanner
                        currentSize={currentSize}
                        currentStyle={currentStyle}
                        salesChannelContentUuid={contentUuid}
                        isPrimary={isOnPrimaryLanguage}
                      />
                    </React.Fragment>
                  ),
                  key: 'topConfig',
                },
              ];
            } else {
              return [
                {
                  body: (
                    <React.Fragment>
                      <TopLeaderBoardBanner
                        currentSize={currentSize}
                        currentStyle={currentStyle}
                        salesChannelContentUuid={contentUuid}
                        isPrimary={isOnPrimaryLanguage}
                      />
                    </React.Fragment>
                  ),
                  key: 'Font',
                },
              ];
            }
          }
          case EPreviewSize.MOBILE: {
            if (isOnPrimaryLanguage) {
              return [
                {
                  body: (
                    <React.Fragment>
                      <TopLeaderBoardBanner
                        currentSize={currentSize}
                        currentStyle={currentStyle}
                        salesChannelContentUuid={contentUuid}
                        isPrimary={isOnPrimaryLanguage}
                      />
                    </React.Fragment>
                  ),
                  key: 'topConfig',
                },
              ];
            } else {
              return [
                {
                  body: (
                    <React.Fragment>
                      <TopLeaderBoardBanner
                        currentSize={currentSize}
                        currentStyle={currentStyle}
                        salesChannelContentUuid={contentUuid}
                        isPrimary={isOnPrimaryLanguage}
                      />
                    </React.Fragment>
                  ),
                  key: 'Font',
                },
              ];
            }
          }
        }
      }
    }
  }, [isOnPrimaryLanguage, currentSize, currentStyle]);

  return (
    <React.Fragment>
      {/* <RouteBlock hasModified={false} /> */}
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel, //salesChannel
          salesChannelName,
          onDiscard: onDiscard,
          onGoBack: onDiscard,
          hasStyleSelect: !isMini && true,
        }}
        leftChild={
          <PreviewStyleSwitch
            style={currentStyle}
            styleChild={
              <div
                style={{
                  height: 10000,
                  backgroundColor: 'green',
                  // margin: '0 auto',
                }}>
                123
              </div>
            }
            normalChild={
              <PreviewWrapper>
                <Preview channelType={channelType} />
              </PreviewWrapper>
            }
          />
        }
        rightChild={
          //loaded
          loaded ? (
            <RightConfigWrapper
              title={getI18nFromGeneral('general.sider.appearance')}
              elements={ele}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
};
export default BasicPageHOC(SalesChannelAppearanceEditorPage, {
  getState,
  siteStyleInParams: true,
  previewSizeInParams: true,
  convertDataFromReduxToServer,
  submit: submitContentAppearance,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  hasRouteBlock: true,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentAppearance({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
